import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ExpectedBillModel } from '../models/expected-bill.model';
import { ExpectedBillService } from '../services/expected-bill.service';

@Injectable()
export class ExpectedBillsResolver implements Resolve<Array<ExpectedBillModel>> {

    constructor(private service: ExpectedBillService) 
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<Array<ExpectedBillModel>> {
        return this.service.GetExpectedBills();
    }
}
